import {inject, injectable} from 'inversify';

import type {Expand, MaybeExpanded} from '../../../../api/types';
import type {CourseMapperJrpc} from '../../Course/mappers/Course.mapper.jrpc';

import {type SubgoalApiModel} from '../../../../api/goal';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';
import {CourseExpandJrpc} from '../../Course/mappers/Course.expand.jrpc';
import {ProgramExpandJrpc} from '../../Program/mappers/Program.expand.jrpc';
import {ProgramMapperJrpc} from '../../Program/mappers/Program.mapper.jrpc';

@injectable()
export class GoalExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(CourseExpandJrpc)
    private readonly courseExpandJrpc: CourseExpandJrpc,
    @inject(ProgramExpandJrpc)
    private readonly programExpandJrpc: ProgramExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      goal: [
        'subgoal_ids',
        ['course_id', null, this.courseExpandJrpc.getByEnv(key)],
        ['program_id', null, this.programExpandJrpc.getByEnv(key)],
      ],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace GoalExpandJrpc {
  export type ExpandedFields = {
    course: MaybeExpanded<CourseMapperJrpc.ExpandedApiData>;
    program: MaybeExpanded<ProgramMapperJrpc.ExpandedApiData>;
    subgoals: MaybeExpanded<SubgoalApiModel>[];
  };
}
